// import React,{useState} from 'react'
// import logo from '../imgs/LME.jpg'
// import '../css/navbar.css'

// import { Link } from 'react-router-dom';

// export const Navbar1 = () => {
//     const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

//     const toggleMobileMenu = () => {
//       setMobileMenuOpen(!isMobileMenuOpen);
//     };
//   return (
//     <div>
//            <header className="header">
//       <a href="/" className="logo" >
//       <img src={logo} alt='logo'  loading='lazy'/>      </a>
//       <nav className={`navbar ${isMobileMenuOpen ? 'active' : ''}`}>
//       <Link to="/">Home</Link>
//       <Link to="/ongoingprojects">On-Going Projects</Link>
     
//       </nav>
//       <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
//         &#9776; {/* Hamburger icon */}
//       </div>
//     </header>

   
   
//     </div>
//   )
// }


import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../imgs/LME.jpg';
import '../css/navbar.css';

export const Navbar1 = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  useEffect(() => {
    // Close menu on route change
    closeMobileMenu();
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isSticky ? 'sticky' : ''}`}>
      <Link to="/" className="logo">
        <img src={logo} alt="logo" loading="lazy" />
      </Link>

      <nav className={`navbar ${isMobileMenuOpen ? 'active' : ''}`}>
        <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link>
        <Link to="/ongoingprojects" className={location.pathname === '/ongoingprojects' ? 'active' : ''}>
          Completed Projects
        </Link>
         <Link to="/comingsoon" className={location.pathname === '/comingsoon' ? 'active' : ''}>
          Ongoing Projects
        </Link>
        <Link to="/upcoming" className={location.pathname === '/upcoming' ? 'active' : ''}>
          Upcoming Projects
        </Link>
        <Link to="/moviepromotions" className={location.pathname === '/moviepromotions' ? 'active' : ''}>
          Movie Promotions
        </Link>
      </nav>

      <div className={`mobile-menu-icon ${isMobileMenuOpen ? 'open' : ''}`} onClick={toggleMobileMenu}>
        <div className="bar1"></div>
        <div className="bar2"></div>
        <div className="bar3"></div>
      </div>
    </header>
  );
};

